<template>
	<div class="flex flex-col items-center w-dvw min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom)">
		<div class="flex w-dvw h-[calc(100dvh-3.75rem)] lg:h-[calc(100dvh-4rem)] z-1 items-center justify-center relative">
			<!-- Save the Date Video -->
			<video
				src="/assets/Brennan_and_Grant_Save_the_Date.mp4"
				autoplay
				loop
				muted
				playsinline
				class="absolute object-cover size-full -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
			/>
			<div class="flex flex-col gap-2 z-2 text-center items-center text-(--primary-beige)">
				<h1 class="text-5xl md:text-6xl lg:text-8xl tracking-wider lg:tracking-widest font-(family-name:--sloop-script)! text-shadow-sm text-shadow-black/25">
					Brennan & Grant
				</h1>
				<h1 class="text-2xl md:text-3xl lg:text-4xl tracking-tighter lg:tracking-tight font-extralight! uppercase text-shadow-sm text-shadow-black/25">
					May 29, 2027
				</h1>
				<h1 class="text-2xl md:text-3xl lg:text-4xl tracking-tighter lg:tracking-tight font-extralight! uppercase text-shadow-sm text-shadow-black/25">
					Brooklyn, New York
				</h1>
				<button
					id="next-section-button"
					class="hover:cursor-pointer hover:scale-105 transition duration-(--default-transition-duration) opacity-0"
					@click="goToNextSection"
				>
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
						class="size-12 rotate-180 text-shadow-sm text-shadow-black/25 animate-bounce-custom"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M4.5 18.75l7.5-7.5 7.5 7.5M4.5 12.75l7.5-7.5 7.5 7.5"
						/>
					</svg>
				</button>
			</div>
		</div>
		<div
			id="favorite-people"
			class="flex flex-col w-dvw h-dvh items-center justify-center"
		>
			<NYCSkyline class="w-4/5 lg:w-1/3 skyline" />
			<span class="w-4/5 lg:w-1/3 text-center">
				You are our most important people. We cannot wait to celebrate and share our love with you. Thank you for being by our side, growing, and supporting us on our journey.
			</span>
		</div>

		<!-- The Wedding -->
		<div class="flex flex-col w-[90dvw] min-h-dvh justify-center items-center text-center gap-16 pb-8 lg:pb-0">
			<div class="flex flex-col">
				<h1 class="text-6xl lg:text-8xl tracking-wider lg:tracking-widest font-(family-name:--sloop-script)!">
					The
				</h1>
				<h1 class="text-5xl lg:text-8xl tracking-tighter lg:tracking-tight font-extralight! uppercase -mt-3 lg:-mt-6">
					Wedding
				</h1>
				<div class="flex w-full flex-col 2xs:flex-row items-center justify-center gap-x-2 text-sm sm:text-lg lg:text-xl tracking-tighter lg:tracking-tight font-extralight! uppercase mt-2 md:mt-3">
					<span>Shell's Loft</span>
					<span class="hidden 2xs:block">&bull;</span>
					<Divider class="w-32! 2xs:hidden!" />
					<span>11 Adelphi St, Brooklyn, NY 11205</span>
				</div>
			</div>
			<div class="flex flex-col lg:flex-row w-full justify-around gap-16 lg:gap-0 mb-8 lg:mb-0">
				<div class="flex flex-col w-full lg:w-1/5 gap-2 items-center">
					<img
						src="/assets/Olive_Green_Fresh_Florals.svg"
						alt="Olive Green Fresh Florals"
					>
					<span class="text-xl lg:text-3xl tracking-tighter! lg:tracking-tight! font-extralight!">Ceremony</span>
					<span class="">
						The ceremony will take place in the courtyard of Shell’s Loft.
					</span>
				</div>
				<div class="flex flex-col w-full lg:w-1/5 gap-2 items-center">
					<img
						src="/assets/Patio.svg"
						alt="Outdoor Patio with String Lights"
					>
					<span class="text-xl lg:text-3xl tracking-tighter! lg:tracking-tight! font-extralight!">Cocktail Hour</span>
					<span class="">
						Following the ceremony, there will be cocktail hour with an open bar and passed hor d’oeuvres.
					</span>
				</div>
				<div class="flex flex-col w-full lg:w-1/5 gap-2 items-center">
					<img
						src="/assets/Flower.svg"
						alt="Flower"
					>
					<span class="text-xl lg:text-3xl tracking-tighter! lg:tracking-tight! font-extralight!">Reception</span>
					<span class="">
						The reception will be a three-course plated meal followed by music and dancing until the end of the night.
					</span>
				</div>
			</div>
		</div>
		<OurStory />
	</div>
</template>

<script setup lang="ts">
	import NYCSkyline from "~/components/icons/NYCSkyline.vue";
	import OurStory from "~/components/OurStory.vue";
	import {
		Divider
	} from "primevue";
	import {
		gsap
	} from "gsap";

	const goToNextSection = () => {
		const favoritePeopleTop = document.getElementById( "favorite-people" )?.offsetTop;
		scrollTo( {
			top: favoritePeopleTop,
			behavior: "smooth"
		} );
	};

	onMounted( () => {
		setTimeout( () => {
			gsap.to( "#next-section-button", {
				opacity: 1,
				duration: 0.2
			} );
		}, 3000 );
	} );
</script>

<style scoped>

</style>